import * as React from "react"

import { cn } from "@/lib/utils"

interface FloatingPanelProps extends Omit<React.ComponentProps<"div">, "title"> {
  title?: React.ReactNode
  headerActions?: React.ReactNode
}

/** Themed floating panel shell for viewport toolbars (optional title + header actions). */
function FloatingPanel({
  className,
  children,
  title,
  headerActions,
  ...props
}: FloatingPanelProps) {
  const hasHeader = title != null || headerActions != null

  return (
    <div
      data-slot="floating-panel"
      className={cn(
        "rounded-lg border-2 border-border bg-background/95 p-3 shadow-xl backdrop-blur",
        className
      )}
      {...props}
    >
      {hasHeader ? (
        <div className="mb-3 flex items-center justify-between gap-2">
          {title != null ? (
            <div className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              {title}
            </div>
          ) : null}
          {headerActions}
        </div>
      ) : null}
      {children}
    </div>
  )
}

export { FloatingPanel }
